// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attribution-dashboard {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 98%;
  height: 100%;
  max-height: 100%;
  margin: 0 auto 18px;
  overflow: hidden;
  color: #17325c;
  font-family: "opensans", sans-serif;
  /* Horizontal scroll only on narrow viewports; height follows content (10 rows per page via pagination). */
}
.attribution-dashboard__heading, .attribution-dashboard__subheading, .attribution-dashboard__card-title, .attribution-dashboard__card-subtitle, .attribution-dashboard__kpi-label, .attribution-dashboard__kpi-value, .attribution-dashboard__kpi-copy, .attribution-dashboard__axis-title, .attribution-dashboard__funnel-label-row, .attribution-dashboard__funnel-dropoff, .attribution-dashboard__legend-inline, .attribution-dashboard__sankey-label, .attribution-dashboard__table-head, .attribution-dashboard__search, .attribution-dashboard__table th, .attribution-dashboard__badge, .attribution-dashboard__select-trigger, .attribution-dashboard__select-option {
  font-family: "opensans", sans-serif;
}
.attribution-dashboard__header {
  flex-shrink: 0;
  margin-bottom: 12px;
}
.attribution-dashboard__header .dashboard-section-header__main {
  align-items: flex-start;
}
.attribution-dashboard__header .dashboard-section-header__actions--filters {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}
.attribution-dashboard__header .dashboard-section-header__control {
  min-width: 200px;
  max-width: 260px;
}
.attribution-dashboard__heading {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #101828;
  font-family: "opensans", sans-serif;
  text-align: left;
}
.attribution-dashboard__subheading {
  margin: 4px 0 0;
  font-size: 12px;
  color: #667085;
}
.attribution-dashboard__filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  overflow: visible;
}
.attribution-dashboard__select-menu {
  position: relative;
  min-width: 220px;
}
.attribution-dashboard__select-trigger {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #c9d3e2;
  background: #ffffff;
  color: #1f2937;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.attribution-dashboard__select-trigger--open {
  border-color: #b8c5d8;
}
.attribution-dashboard__select-icon {
  color: #6b7280;
  transition: transform 0.2s ease;
}
.attribution-dashboard__select-trigger--open .attribution-dashboard__select-icon {
  transform: rotate(180deg);
}
.attribution-dashboard__select-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  border: 1px solid #e6edf7;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  padding: 6px;
  z-index: 40;
}
.attribution-dashboard__select-option {
  width: 100%;
  border: 0;
  background: transparent;
  border-radius: 8px;
  min-height: 40px;
  padding: 10px 12px;
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  color: #1f2937;
  font-size: 13px;
  cursor: pointer;
  text-align: left;
  transition: background 0.2s ease, color 0.2s ease;
}
.attribution-dashboard__select-option:hover {
  background: #f2f2f2;
}
.attribution-dashboard__select-option--active {
  background: #e4e4e4;
  color: #1f1f1f;
  font-weight: 600;
}
.attribution-dashboard__select-check {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #111827;
}
.attribution-dashboard__main {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.attribution-dashboard__card {
  background: #ffffff;
  border: 1px solid #e4e9f2;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);
  padding: 20px;
}
.attribution-dashboard__card--full {
  width: 100%;
}
.attribution-dashboard__card--analytics-flat {
  border: none;
  box-shadow: none;
  background: transparent;
}
.attribution-dashboard__card-head {
  margin-bottom: 10px;
}
.attribution-dashboard__card-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #101828;
}
.attribution-dashboard__card-subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  color: #667085;
}
.attribution-dashboard__kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}
.attribution-dashboard__kpi-card {
  padding: 24px;
}
.attribution-dashboard__kpi-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.attribution-dashboard__kpi-label {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 700;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.attribution-dashboard__kpi-value {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
  color: #101828;
  line-height: 1.2;
}
.attribution-dashboard__kpi-trend-copy {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.attribution-dashboard__kpi-copy {
  margin: 4px 0 0;
  font-size: 11px;
  color: #2f6edb;
  font-weight: 600;
}
.attribution-dashboard__kpi-icon {
  width: 38px;
  height: 38px;
  border-radius: 9px;
  background: rgba(47, 110, 219, 0.14);
  color: #2f6edb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.attribution-dashboard__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.attribution-dashboard__chart {
  width: 100%;
  height: 320px;
}
.attribution-dashboard .recharts-default-legend {
  padding-top: 4px !important;
}
.attribution-dashboard .recharts-default-legend .recharts-legend-item {
  display: inline-flex !important;
  align-items: center !important;
  margin-right: 14px !important;
}
.attribution-dashboard .recharts-default-legend .recharts-legend-item .recharts-surface {
  display: inline-block !important;
  width: 12px !important;
  height: 12px !important;
  flex: 0 0 12px !important;
}
.attribution-dashboard .recharts-default-legend .recharts-legend-item-text {
  font-size: 12px !important;
  line-height: 1.2;
}
.attribution-dashboard__chart--small {
  height: 258px;
}
.attribution-dashboard__funnel {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 2px;
}
.attribution-dashboard__funnel-stage {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.attribution-dashboard__funnel-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 600;
  color: #101828;
}
.attribution-dashboard__funnel-dropoff {
  margin-left: 8px;
  color: #d9534f;
  font-weight: 700;
  font-size: 11px;
}
.attribution-dashboard__funnel-bar {
  height: 38px;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  margin: 0 auto;
  min-width: 20%;
}
.attribution-dashboard__legend-inline {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  font-size: 11px;
  color: #667085;
  max-width: 640px;
  margin: 2px auto 0;
}
.attribution-dashboard__legend-inline span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.attribution-dashboard__legend-inline i {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  display: inline-block;
}
.attribution-dashboard__sankey-wrap {
  width: 100%;
  overflow-x: auto;
}
.attribution-dashboard__sankey {
  width: 100%;
  min-width: 400px;
  height: auto;
}
.attribution-dashboard__sankey-label {
  font-size: 11px;
  fill: #101828;
  font-weight: 500;
}
.attribution-dashboard__dual-chart {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.attribution-dashboard__axis-title {
  margin: 0 0 6px;
  color: #667085;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.06em;
}
.attribution-dashboard__heatmap-wrap {
  overflow-x: auto;
}
.attribution-dashboard__heatmap {
  width: 100%;
  border-collapse: separate !important;
  border-spacing: 10px 10px !important;
  font-size: 11px;
  background: transparent;
}
.attribution-dashboard__heatmap th {
  text-align: center;
  color: #667085;
  font-weight: 600;
  white-space: nowrap;
  background: transparent !important;
  border: 0 !important;
  padding: 0 4px 4px;
}
.attribution-dashboard__heatmap th:first-child, .attribution-dashboard__heatmap td:first-child {
  text-align: left;
  font-weight: 700;
  color: #101828;
  white-space: nowrap;
  min-width: 120px;
  background: transparent !important;
  border: 0 !important;
  padding: 0 8px 0 0;
}
.attribution-dashboard__heatmap tr, .attribution-dashboard__heatmap tbody tr, .attribution-dashboard__heatmap td {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}
.attribution-dashboard__heatmap td {
  padding: 0;
}
.attribution-dashboard__heat-cell {
  border-radius: 8px;
  min-height: 48px;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
}
.attribution-dashboard__heat-cell--level-5 {
  background: #2f6edb;
  color: #fff;
}
.attribution-dashboard__heat-cell--level-4 {
  background: rgba(47, 110, 219, 0.72);
  color: #fff;
}
.attribution-dashboard__heat-cell--level-3 {
  background: rgba(47, 110, 219, 0.45);
  color: #101828;
}
.attribution-dashboard__heat-cell--level-2 {
  background: rgba(47, 110, 219, 0.22);
  color: #101828;
}
.attribution-dashboard__heat-cell--level-1 {
  background: rgba(47, 110, 219, 0.11);
  color: #667085;
}
.attribution-dashboard__data-table-panel {
  width: 100%;
}
.attribution-dashboard__data-table-panel .dashboard-data-table-panel__header {
  align-items: flex-start;
}
.attribution-dashboard__panel-header-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
  min-width: 0;
  flex: 1 1 240px;
}
.attribution-dashboard__panel-header-text .attribution-dashboard__card-subtitle {
  margin: 0;
}
.attribution-dashboard__table-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.attribution-dashboard__search {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #d6deeb;
  border-radius: 8px;
  padding: 0 10px;
  height: 36px;
  color: #667085;
  min-width: 250px;
  background: #fff;
}
.attribution-dashboard__search input {
  border: 0;
  width: 100%;
  outline: 0;
  font-size: 12px;
  color: #17325c;
  background: transparent;
}
.attribution-dashboard__table-wrap {
  overflow-x: auto;
  overflow-y: visible;
}
.attribution-dashboard__table.dashboard-data-table {
  font-size: 13px;
  width: 100%;
}
.attribution-dashboard__table.dashboard-data-table thead tr {
  position: sticky;
  top: 0;
  z-index: 2;
}
.attribution-dashboard__table.dashboard-data-table td {
  color: #0f172a;
}
.attribution-dashboard__mono {
  font-family: "Courier New", monospace;
  font-weight: 700;
  color: #101828 !important;
}
.attribution-dashboard__channel-dot-wrap {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.attribution-dashboard__channel-dot-wrap i {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
.attribution-dashboard__badge {
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
  display: inline-block;
  background: #f2f4f7;
  color: #475467;
  border: 1px solid transparent;
}
.attribution-dashboard__badge--primary {
  background: #2f6edb;
  color: #ffffff;
}
.attribution-dashboard__badge--success {
  background: #4e7fe4;
  color: #ffffff;
}
.attribution-dashboard__badge--outline {
  background: #fff;
  border-color: #d0d5dd;
  color: #475467;
}
.attribution-dashboard__empty {
  text-align: center;
  padding: 24px !important;
  color: #667085 !important;
}

@media (max-width: 1199px) {
  .attribution-dashboard__kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 991px) {
  .attribution-dashboard__grid, .attribution-dashboard__dual-chart {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 767px) {
  .attribution-dashboard {
    width: 100%;
    padding: 0 8px 12px;
  }
  .attribution-dashboard__header {
    position: static;
    padding-top: 4px;
  }
  .attribution-dashboard__kpi-grid {
    grid-template-columns: 1fr;
  }
  .attribution-dashboard__search {
    min-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/attribution/components/AttributionDashboard.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EA8gBA,0GAAA;AA5gBF;AAAE;EAkBE,mCAAA;AAfJ;AAkBE;EACE,cAAA;EACA,mBAAA;AAhBJ;AAkBI;EACE,uBAAA;AAhBN;AAmBI;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AAjBN;AAoBI;EACE,gBAAA;EACA,gBAAA;AAlBN;AAsBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;AApBJ;AAuBE;EACE,eAAA;EACA,eAAA;EACA,cAAA;AArBJ;AAwBE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAtBJ;AAyBE;EACE,kBAAA;EACA,gBAAA;AAvBJ;AA0BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAxBJ;AA2BE;EACE,qBAAA;AAzBJ;AA4BE;EACE,cAAA;EACA,+BAAA;AA1BJ;AA6BE;EACE,yBAAA;AA3BJ;AA8BE;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,YAAA;EACA,WAAA;AA5BJ;AA+BE;EACE,WAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iDAAA;AA7BJ;AAgCE;EACE,mBAAA;AA9BJ;AAiCE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AA/BJ;AAkCE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAhCJ;AAmCE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAjCJ;AAoCE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,4CAAA;EACA,aAAA;AAlCJ;AAqCE;EACE,WAAA;AAnCJ;AAsCE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;AApCJ;AAuCE;EACE,mBAAA;AArCJ;AAwCE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAtCJ;AAyCE;EACE,eAAA;EACA,eAAA;EACA,cAAA;AAvCJ;AA0CE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAxCJ;AA2CE;EACE,aAAA;AAzCJ;AA4CE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA1CJ;AA6CE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AA3CJ;AA8CE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,gBAAA;AA5CJ;AA+CE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AA7CJ;AAgDE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA9CJ;AAiDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA/CJ;AAkDE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAhDJ;AAmDE;EACE,WAAA;EACA,aAAA;AAjDJ;AAoDE;EACE,2BAAA;AAlDJ;AAqDE;EACE,+BAAA;EACA,8BAAA;EACA,6BAAA;AAnDJ;AAsDE;EACE,gCAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AApDJ;AAuDE;EACE,0BAAA;EACA,gBAAA;AArDJ;AAwDE;EACE,aAAA;AAtDJ;AAyDE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAvDJ;AA0DE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAxDJ;AA2DE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAzDJ;AA4DE;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA1DJ;AA6DE;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;AA3DJ;AA8DE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AA5DJ;AA+DE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AA7DJ;AAgEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AA9DJ;AAiEE;EACE,WAAA;EACA,gBAAA;AA/DJ;AAkEE;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAhEJ;AAmEE;EACE,eAAA;EACA,aAAA;EACA,gBAAA;AAjEJ;AAoEE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAlEJ;AAqEE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;AAnEJ;AAsEE;EACE,gBAAA;AApEJ;AAuEE;EACE,WAAA;EACA,oCAAA;EACA,oCAAA;EACA,eAAA;EACA,uBAAA;AArEJ;AAwEE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;EACA,oBAAA;EACA,kBAAA;AAtEJ;AAyEE;EAEE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kCAAA;EACA,oBAAA;EACA,kBAAA;AAxEJ;AA2EE;EAGE,kCAAA;EACA,oBAAA;EACA,2BAAA;AA3EJ;AA8EE;EACE,UAAA;AA5EJ;AA+EE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA7EJ;AAgFE;EACE,mBAAA;EACA,WAAA;AA9EJ;AAiFE;EACE,oCAAA;EACA,WAAA;AA/EJ;AAkFE;EACE,oCAAA;EACA,cAAA;AAhFJ;AAmFE;EACE,oCAAA;EACA,cAAA;AAjFJ;AAoFE;EACE,oCAAA;EACA,cAAA;AAlFJ;AAqFE;EACE,WAAA;AAnFJ;AAsFE;EACE,uBAAA;AApFJ;AAuFE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AArFJ;AAwFE;EACE,SAAA;AAtFJ;AAyFE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAvFJ;AA0FE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAxFJ;AA2FE;EACE,SAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;AAzFJ;AA6FE;EACE,gBAAA;EACA,mBAAA;AA3FJ;AA8FE;EACE,eAAA;EACA,WAAA;AA5FJ;AA+FE;EACE,gBAAA;EACA,MAAA;EACA,UAAA;AA7FJ;AAgGE;EACE,cAAA;AA9FJ;AAiGE;EACE,qCAAA;EACA,gBAAA;EACA,yBAAA;AA/FJ;AAkGE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAhGJ;AAmGE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AAjGJ;AAoGE;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;AAlGJ;AAqGE;EACE,mBAAA;EACA,cAAA;AAnGJ;AAsGE;EACE,mBAAA;EACA,cAAA;AApGJ;AAuGE;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AArGJ;AAwGE;EACE,kBAAA;EACA,wBAAA;EACA,yBAAA;AAtGJ;;AA0GA;EAEI;IACE,gDAAA;EAxGJ;AACF;AA4GA;EAEI;IAEE,0BAAA;EA5GJ;AACF;AAgHA;EACE;IACE,WAAA;IACA,mBAAA;EA9GF;EAgHE;IACE,gBAAA;IACA,gBAAA;EA9GJ;EAiHE;IACE,0BAAA;EA/GJ;EAkHE;IACE,eAAA;EAhHJ;AACF","sourcesContent":[".attribution-dashboard {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 98%;\n  height: 100%;\n  max-height: 100%;\n  margin: 0 auto 18px;\n  overflow: hidden;\n  color: #17325c;\n  font-family: \"opensans\", sans-serif;\n\n  &__heading,\n  &__subheading,\n  &__card-title,\n  &__card-subtitle,\n  &__kpi-label,\n  &__kpi-value,\n  &__kpi-copy,\n  &__axis-title,\n  &__funnel-label-row,\n  &__funnel-dropoff,\n  &__legend-inline,\n  &__sankey-label,\n  &__table-head,\n  &__search,\n  &__table th,\n  &__badge,\n  &__select-trigger,\n  &__select-option {\n    font-family: \"opensans\", sans-serif;\n  }\n\n  &__header {\n    flex-shrink: 0;\n    margin-bottom: 12px;\n\n    .dashboard-section-header__main {\n      align-items: flex-start;\n    }\n\n    .dashboard-section-header__actions--filters {\n      display: flex;\n      flex-wrap: nowrap;\n      align-items: center;\n      justify-content: flex-end;\n      gap: 12px;\n    }\n\n    .dashboard-section-header__control {\n      min-width: 200px;\n      max-width: 260px;\n    }\n  }\n\n  &__heading {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: #101828;\n    font-family: 'opensans', sans-serif;\n    text-align: left;\n  }\n\n  &__subheading {\n    margin: 4px 0 0;\n    font-size: 12px;\n    color: #667085;\n  }\n\n  &__filters {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px;\n    overflow: visible;\n  }\n\n  &__select-menu {\n    position: relative;\n    min-width: 220px;\n  }\n\n  &__select-trigger {\n    width: 100%;\n    height: 44px;\n    border-radius: 8px;\n    border: 1px solid #c9d3e2;\n    background: #ffffff;\n    color: #1f2937;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1;\n    padding: 0 14px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n  }\n\n  &__select-trigger--open {\n    border-color: #b8c5d8;\n  }\n\n  &__select-icon {\n    color: #6b7280;\n    transition: transform 0.2s ease;\n  }\n\n  &__select-trigger--open &__select-icon {\n    transform: rotate(180deg);\n  }\n\n  &__select-dropdown {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    width: 100%;\n    border: 1px solid #e6edf7;\n    border-radius: 12px;\n    background: #ffffff;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n    padding: 6px;\n    z-index: 40;\n  }\n\n  &__select-option {\n    width: 100%;\n    border: 0;\n    background: transparent;\n    border-radius: 8px;\n    min-height: 40px;\n    padding: 10px 12px;\n    display: grid;\n    grid-template-columns: 20px minmax(0, 1fr);\n    align-items: center;\n    gap: 10px;\n    color: #1f2937;\n    font-size: 13px;\n    cursor: pointer;\n    text-align: left;\n    transition: background 0.2s ease, color 0.2s ease;\n  }\n\n  &__select-option:hover {\n    background: #f2f2f2;\n  }\n\n  &__select-option--active {\n    background: #e4e4e4;\n    color: #1f1f1f;\n    font-weight: 600;\n  }\n\n  &__select-check {\n    width: 18px;\n    height: 18px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: #111827;\n  }\n\n  &__main {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__card {\n    background: #ffffff;\n    border: 1px solid #e4e9f2;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);\n    padding: 20px;\n  }\n\n  &__card--full {\n    width: 100%;\n  }\n\n  &__card--analytics-flat {\n    border: none;\n    box-shadow: none;\n    background: transparent;\n  }\n\n  &__card-head {\n    margin-bottom: 10px;\n  }\n\n  &__card-title {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 700;\n    color: #101828;\n  }\n\n  &__card-subtitle {\n    margin: 4px 0 0;\n    font-size: 12px;\n    color: #667085;\n  }\n\n  &__kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 12px;\n  }\n\n  &__kpi-card {\n    padding: 24px;\n  }\n\n  &__kpi-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  &__kpi-label {\n    margin: 0 0 4px;\n    font-size: 11px;\n    font-weight: 700;\n    color: #667085;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n  }\n\n  &__kpi-value {\n    margin: 0;\n    font-size: 22px;\n    font-weight: 700;\n    font-family: 'opensans', sans-serif;\n    color: #101828;\n    line-height: 1.2;\n  }\n\n  &__kpi-trend-copy {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  &__kpi-copy {\n    margin: 4px 0 0;\n    font-size: 11px;\n    color: #2f6edb;\n    font-weight: 600;\n  }\n\n  &__kpi-icon {\n    width: 38px;\n    height: 38px;\n    border-radius: 9px;\n    background: rgba(47, 110, 219, 0.14);\n    color: #2f6edb;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 16px;\n  }\n\n  &__chart {\n    width: 100%;\n    height: 320px;\n  }\n\n  .recharts-default-legend {\n    padding-top: 4px !important;\n  }\n\n  .recharts-default-legend .recharts-legend-item {\n    display: inline-flex !important;\n    align-items: center !important;\n    margin-right: 14px !important;\n  }\n\n  .recharts-default-legend .recharts-legend-item .recharts-surface {\n    display: inline-block !important;\n    width: 12px !important;\n    height: 12px !important;\n    flex: 0 0 12px !important;\n  }\n\n  .recharts-default-legend .recharts-legend-item-text {\n    font-size: 12px !important;\n    line-height: 1.2;\n  }\n\n  &__chart--small {\n    height: 258px;\n  }\n\n  &__funnel {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding-top: 2px;\n  }\n\n  &__funnel-stage {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n  }\n\n  &__funnel-label-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 13px;\n    font-weight: 600;\n    color: #101828;\n  }\n\n  &__funnel-dropoff {\n    margin-left: 8px;\n    color: #d9534f;\n    font-weight: 700;\n    font-size: 11px;\n  }\n\n  &__funnel-bar {\n    height: 38px;\n    border-radius: 6px;\n    overflow: hidden;\n    display: flex;\n    margin: 0 auto;\n    min-width: 20%;\n  }\n\n  &__legend-inline {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 12px;\n    font-size: 11px;\n    color: #667085;\n    max-width: 640px;\n    margin: 2px auto 0;\n  }\n\n  &__legend-inline span {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    white-space: nowrap;\n  }\n\n  &__legend-inline i {\n    width: 10px;\n    height: 10px;\n    border-radius: 2px;\n    display: inline-block;\n  }\n\n  &__sankey-wrap {\n    width: 100%;\n    overflow-x: auto;\n  }\n\n  &__sankey {\n    width: 100%;\n    min-width: 400px;\n    height: auto;\n  }\n\n  &__sankey-label {\n    font-size: 11px;\n    fill: #101828;\n    font-weight: 500;\n  }\n\n  &__dual-chart {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 16px;\n  }\n\n  &__axis-title {\n    margin: 0 0 6px;\n    color: #667085;\n    font-size: 11px;\n    text-transform: uppercase;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n  }\n\n  &__heatmap-wrap {\n    overflow-x: auto;\n  }\n\n  &__heatmap {\n    width: 100%;\n    border-collapse: separate !important;\n    border-spacing: 10px 10px !important;\n    font-size: 11px;\n    background: transparent;\n  }\n\n  &__heatmap th {\n    text-align: center;\n    color: #667085;\n    font-weight: 600;\n    white-space: nowrap;\n    background: transparent !important;\n    border: 0 !important;\n    padding: 0 4px 4px;\n  }\n\n  &__heatmap th:first-child,\n  &__heatmap td:first-child {\n    text-align: left;\n    font-weight: 700;\n    color: #101828;\n    white-space: nowrap;\n    min-width: 120px;\n    background: transparent !important;\n    border: 0 !important;\n    padding: 0 8px 0 0;\n  }\n\n  &__heatmap tr,\n  &__heatmap tbody tr,\n  &__heatmap td {\n    background: transparent !important;\n    border: 0 !important;\n    box-shadow: none !important;\n  }\n\n  &__heatmap td {\n    padding: 0;\n  }\n\n  &__heat-cell {\n    border-radius: 8px;\n    min-height: 48px;\n    min-width: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n    line-height: 1;\n  }\n\n  &__heat-cell--level-5 {\n    background: #2f6edb;\n    color: #fff;\n  }\n\n  &__heat-cell--level-4 {\n    background: rgba(47, 110, 219, 0.72);\n    color: #fff;\n  }\n\n  &__heat-cell--level-3 {\n    background: rgba(47, 110, 219, 0.45);\n    color: #101828;\n  }\n\n  &__heat-cell--level-2 {\n    background: rgba(47, 110, 219, 0.22);\n    color: #101828;\n  }\n\n  &__heat-cell--level-1 {\n    background: rgba(47, 110, 219, 0.11);\n    color: #667085;\n  }\n\n  &__data-table-panel {\n    width: 100%;\n  }\n\n  &__data-table-panel .dashboard-data-table-panel__header {\n    align-items: flex-start;\n  }\n\n  &__panel-header-text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    align-items: flex-start;\n    min-width: 0;\n    flex: 1 1 240px;\n  }\n\n  &__panel-header-text .attribution-dashboard__card-subtitle {\n    margin: 0;\n  }\n\n  &__table-head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 12px;\n  }\n\n  &__search {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    border: 1px solid #d6deeb;\n    border-radius: 8px;\n    padding: 0 10px;\n    height: 36px;\n    color: #667085;\n    min-width: 250px;\n    background: #fff;\n  }\n\n  &__search input {\n    border: 0;\n    width: 100%;\n    outline: 0;\n    font-size: 12px;\n    color: #17325c;\n    background: transparent;\n  }\n\n  /* Horizontal scroll only on narrow viewports; height follows content (10 rows per page via pagination). */\n  &__table-wrap {\n    overflow-x: auto;\n    overflow-y: visible;\n  }\n\n  &__table.dashboard-data-table {\n    font-size: 13px;\n    width: 100%;\n  }\n\n  &__table.dashboard-data-table thead tr {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n  }\n\n  &__table.dashboard-data-table td {\n    color: #0f172a;\n  }\n\n  &__mono {\n    font-family: \"Courier New\", monospace;\n    font-weight: 700;\n    color: #101828 !important;\n  }\n\n  &__channel-dot-wrap {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n  }\n\n  &__channel-dot-wrap i {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    display: inline-block;\n  }\n\n  &__badge {\n    border-radius: 999px;\n    padding: 2px 8px;\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 1.2;\n    display: inline-block;\n    background: #f2f4f7;\n    color: #475467;\n    border: 1px solid transparent;\n  }\n\n  &__badge--primary {\n    background: #2f6edb;\n    color: #ffffff;\n  }\n\n  &__badge--success {\n    background: #4e7fe4;\n    color: #ffffff;\n  }\n\n  &__badge--outline {\n    background: #fff;\n    border-color: #d0d5dd;\n    color: #475467;\n  }\n\n  &__empty {\n    text-align: center;\n    padding: 24px !important;\n    color: #667085 !important;\n  }\n}\n\n@media (max-width: 1199px) {\n  .attribution-dashboard {\n    &__kpi-grid {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .attribution-dashboard {\n    &__grid,\n    &__dual-chart {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n@media (max-width: 767px) {\n  .attribution-dashboard {\n    width: 100%;\n    padding: 0 8px 12px;\n\n    &__header {\n      position: static;\n      padding-top: 4px;\n    }\n\n    &__kpi-grid {\n      grid-template-columns: 1fr;\n    }\n\n    &__search {\n      min-width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
